<template>
  <div :class="['editable-cell', editPermission ? '' : 'disabled']" @click="edit">
    <div v-if="editable" class="editable-cell-input-wrapper">
      <Popover v-model="visible" title="货物列表" trigger="click" v-if="search" placement="bottomLeft">
        <template slot="content">
          <div class="cellTableWrapper">
            <Table
              :data-source="objectList"
              :customRow="customRow"
              :scroll="{ y: 300 }"
              :rowKey="getRowKey"
              :columns="columns"
              :pagination="pagination"
              @change="handleFilterChange"
              :key="tableNumber"
            />
          </div>
        </template>
        <Input :type="inputType" :value="value" @change="handleChange" @pressEnter="check"/>
      </Popover>


      <Input
        :value="value"
        :type="inputType"
        @change="handleChange"
        @pressEnter="check"
        v-if="!search"
        :style="{ width: `${width}px` }"
      />
      <i
        class="iconfont editable-cell-icon-check"
        @click.stop="check"
      >&#xe6e5;</i>
    </div>
    <div v-else class="editable-cell-text-wrapper">
      {{ ((!text && text ==0) || text) ? text : ''}}
      <!-- <i v-if="editPermission" class="iconfont editable-cell-icon" >&#xe666;</i> -->
    </div>
  </div>
</template>

<script>
import { Popover, Input, Table } from 'ant-design-vue';
import 'ant-design-vue/es/popover/style/css';
import 'ant-design-vue/es/input/style/css';
import 'ant-design-vue/es/table/style/css';
import { mapState } from 'vuex';

export default {
  props: {
    text: [String, Number],
    editPermission: Boolean,
    search: Boolean,
    objectList: Array,
    objectTotal: Number,
    inputType: String,
    modifiedPermission: {
      type: Boolean,
      default: true
    },
    tableKey: String,
    width: Number,
    
  },
  components: {
    Input, Popover, Table
  },
  mounted() {
    this.classesFilter = this.classFilter;
    this.typeFilter = this.basicMaterialFilter;
    this.columns = [
      {
        title: '分类',
        dataIndex: 'class',
        filters: this.classesFilter,
        filterMultiple: false,
      },
      {
        title: '板材颜色',
        dataIndex: 'color',
      },
      {
        title: '基材',
        dataIndex: 'type',
        filters: this.typeFilter,
        filterMultiple: false,
      },
      {
        title: '厚度',
        dataIndex: 'thick',
      },
      {
        title: '规格',
        dataIndex: 'spec',
      },
      
      {
        title: '数量',
        dataIndex: 'count',
      },
      {
        title: '品牌',
        dataIndex: 'brand'
      },
      {
        title: '贴面工艺',
        dataIndex: 'texture_method'
      },
      {
        title: '板材名称',
        dataIndex: 'name',
      },
      {
        title: '钢板纹理',
        dataIndex: 'texture'
      },
      {
        title: '板材备注',
        dataIndex: 'remark'
      }
    ]
  },
  computed: {
    ...mapState([
      'classFilter', 'basicMaterialFilter'
    ]),
    pagination() {
      return {
        defaultPageSize: 10,
        defaultCurrent: 1,
        total: this.objectTotal,
        // onChange: (page) => {
        //   this.$emit('inner-table-page-change', this.tableKey, page, this.value);
        // }
      };
    },
  },
  watch: {
    text(value) {
      console.log('///',value)
      this.value = value;
    },
    classFilter(value) {
      this.classesFilter = value;
      this.columns.forEach((item) => {
        if (item.dataIndex == 'class') {
          item.filters = value
        }
      });
    },
    basicMaterialFilter(value) {
      this.typeFilter = value;
      this.columns.forEach((item) => {
        if (item.dataIndex == 'type') {
          item.filters = value;
        }
      })
    }
  },
  data() {
    return {
      tableNumber: 0, // 用于控制表格的key，以便想要清空筛选条件时，可以重新渲染表格
      test: false,
      visible: true, // 控制弹出的表格是否显示
      value: this.text, // 要用watch监听属性改变赋值，否则表格更新时，这个字段来不及更新
      editable: false,
      classesFilter: [],
      typeFilter: [],
      columns: [],
      chosedClass: undefined,
      chosedType: undefined,
    };
  },
  methods: {
    clearFilters() {
      this.tableNumber = Math.random(1, 10);
      console.log('clear filters, ', this.tableNumber);
    },
    handleFilterChange(pagination, filters) {
      const filter = {
        class: filters.class && filters.class[0],
        type: filters.type && filters.type[0]
      }
      const { tableKey, value } = this;
      this.$emit('filter-change', { filter, pagination, tableKey, value });
    },
    getRowKey(record, index) {
      return index;
    },
    customRow(record) {
      return {
        on: {
          click: () => {
            this.$emit('chose-item', record);
            this.editable = false; // 表格恢复成不在编辑状态
            this.visible = false; // 收起弹出层
          }
        }
      }
    },
    handleChange(e) {
      const value = e.target.value;
      this.value = value;

      // 清空选项
      this.clearFilters();
      this.$emit('change', this.value); // 输入变化获取候选项
    },
    check() {
      this.editable = false;
      if (!this.modifiedPermission) return; // 如果该字段是不允许修改到表格中的，则直接返回

      // 清空选项
      this.clearFilters();
      console.log('***',this.value)
      this.$emit('change', this.value);
      this.$emit('select',this.value)
    },
    edit() {
      if (!this.editPermission) return;
      this.editable = true;
      // 每次编辑，value都恢复为当前属性值, 搜索用的框不保存当前输入状态
      this.value = this.text;

      // 清空选项
      this.clearFilters();
      this.$emit('change', this.value); // 用于点击编辑按钮时就记录当前编辑的行
    },
  },
}
</script>

<style scoped>
@font-face {
  font-family: 'iconfont';  /* project id 1805586 */
  src: url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.eot');
  src: url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.woff') format('woff'),
  url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_1805586_kpnnhtv7v6s.svg#iconfont') format('svg');
}
.iconfont{
  font-family:"iconfont" !important;
  font-size:16px;font-style:normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

.cellTableWrapper {
  width: 1100px;
}
.editable-cell {
  position: relative;
  min-height: 1.5em;
  cursor: pointer;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 5px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  /* right: 0; */
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-top: 20px;
}

.disabled {
  pointer-events: none;
}
</style>